export default __webpack_public_path__ + "static/media/face_2_67.e52a699f.png";